export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-morocco-5340affec277ed90c43c96eb8235283b.jpg";